/* Provencelia, 28/09/2026 : jauge « -15 % dès 500 € de pots » sur la fiche produit.
   Le rendu initial vient de snippets/pv-palier ; ce script la remet à jour après chaque
   changement du panier (ajout depuis la fiche, depuis la pop-up...). Même règle que la
   remise automatique : type Pot, titre sans « MADE IN PROVENCE », prix avant remise.
   Le seuil vient de l'attribut data-seuil (centimes). */
(function () {
  'use strict';

  var COCHE = '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m3 8.5 3.2 3L13 4.5"/></svg>';

  function eligible(item) {
    var type = String(item.product_type || '').toLowerCase();
    return type === 'pot' && !/MADE IN PROVENCE/i.test(item.product_title || '');
  }

  function echapper(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function argent(centimes) {
    var lang = (document.documentElement.lang || 'fr').toLowerCase();
    if (lang.indexOf('fr') === 0) return (centimes / 100).toFixed(2).replace('.', ',') + '€';
    try {
      return new Intl.NumberFormat(lang, { style: 'currency', currency: 'EUR' }).format(centimes / 100);
    } catch (e) {
      return (centimes / 100).toFixed(2) + ' €';
    }
  }

  function racine() {
    try { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; } catch (e) { return '/'; }
  }

  function maj() {
    var blocs = document.querySelectorAll('[data-pv-palier][data-contexte="fiche"]');
    if (!blocs.length) return;
    fetch(racine() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (panier) {
        if (!panier || (panier.currency && panier.currency !== 'EUR')) return;
        var montant = 0;
        (panier.items || []).forEach(function (i) { if (eligible(i)) montant += i.original_line_price; });

        Array.prototype.forEach.call(blocs, function (b) {
          var seuil = parseInt(b.getAttribute('data-seuil'), 10) || 50000;
          var reste = Math.max(0, seuil - montant);
          var pct = Math.min(100, Math.floor(montant * 100 / seuil));
          var barre = b.querySelector('.pv-palier__barre');
          if (barre) {
            barre.setAttribute('aria-valuenow', pct);
            barre.firstElementChild.style.width = pct + '%';
          }
          b.classList.toggle('is-atteint', reste === 0);
          var texte = b.querySelector('[data-pv-palier-texte]');
          if (!texte) return;
          texte.innerHTML = reste === 0
            ? COCHE + '<span>' + echapper(b.getAttribute('data-ok')) + '</span>'
            : '<span>' + echapper(b.getAttribute('data-reste')).replace('[M]', '<strong>' + argent(reste) + '</strong>') + '</span>';
        });
      })
      .catch(function () {});
  }

  var minuteur = null;
  function planifier() {
    clearTimeout(minuteur);
    minuteur = setTimeout(maj, 400);
  }

  document.addEventListener('cart:updated', planifier);
  document.addEventListener('cart:change', planifier);

  function surveiller() {
    // Le tiroir est re-rendu par le thème après chaque ajout : c'est notre signal.
    var tiroir = document.getElementById('cart-drawer');
    if (tiroir && typeof MutationObserver !== 'undefined') {
      new MutationObserver(planifier).observe(tiroir, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', surveiller);
  } else {
    surveiller();
  }
})();
